module.exports = __webpack_public_path__ + "439cd8790bdac0c959f3767120461530.glb";